'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidContact = function IoAndroidContact(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.9 26.4c4.6 1.4 8.1 4.5 9.1 8.6h-30c1-4.1 4.5-7.2 9.1-8.6 1.8 1 3.8 1.6 5.9 1.6s4.1-0.6 5.9-1.6z m-5.9-21.4c5.7 0 10.3 4.6 10.3 10.3s-4.6 10.3-10.3 10.3-10.3-4.6-10.3-10.3 4.6-10.3 10.3-10.3z m0 18c3.3 0 6.1-2 7.2-4.9h-14.4c1.1 2.9 3.9 4.9 7.2 4.9z' })
        )
    );
};

exports.default = IoAndroidContact;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-contact.js
// module id = 2328
// module chunks = 168707334958949